var AjvType = /** @class */ (function () {
    function AjvType() {
    }
    AjvType.requiredString = 'string';
    AjvType.stringOrNull = ['string', 'null'];
    AjvType.requiredNumber = 'number';
    AjvType.numberOrNull = ['number', 'null'];
    AjvType.requiredInteger = 'integer';
    AjvType.integerOrNull = ['integer', 'null'];
    AjvType.requiredArray = 'array';
    AjvType.arrayOrNull = ['array', 'null'];
    return AjvType;
}());
export { AjvType };
//# sourceMappingURL=AjvType.js.map